import { useEffect, useMemo, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { useSelector } from 'react-redux';
import ImageLoader from '../ImageLoader';
import { isEmptyData } from '../../utils/helper';
import CategoryDetail from './Detail/Index';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { twMerge } from 'tailwind-merge';
import check from '../../common/images/revamp/icon/check.svg';

export const ListCategory = (props) => {
	const { handleSelect, id, firstClassName, secondClassName, thirdClassName ,callback } = props;
	const { list: categories = [] } = useSelector((state) => state.category);
	const [selected, setSelected] = useState(new Set());

	const [emblaRef] = useEmblaCarousel({
		align: 'start',
		dragFree: true,
		containScroll: 'trimSnaps',
	});

	const itemsToRender = useMemo(() => {
		if (isEmptyData(categories)) return [];

		return categories?.filter((c) => c?.type?.toUpperCase() === 'CATEGORY');
	}, [categories]);

	const handleSelectMultiple = (id) => {
		setSelected((prevSelected) => {
			const next = new Set(prevSelected);
			if (next.has(id)) {
				if (next.size === 1) return prevSelected;
				next.delete(id);
			} else {
				next.add(id);
			}
			return next;
		});
	};

	useEffect(() => {
		if (isEmptyData(id)) return;
		setSelected(new Set([id]));
	}, [id]);

	useEffect(() => {
		if (callback) {
			callback([...selected].join(','));
		}
	}, [selected]);

	return (
		<div className={`w-full mx-auto mb-4.5 ${isEmptyData(itemsToRender) && 'hidden'} ${firstClassName}`}>
			<div className={`overflow-hidden mx-4 ${secondClassName}`} ref={emblaRef} style={{ touchAction: 'pan-y' }}>
				<div className={`flex gap-5 ${thirdClassName}`}>
					{itemsToRender.map((item, index) => {
						if (!isEmptyData(id)) {
							return (
								<div key={index} className='flex-none w-14 cursor-pointer' onClick={() => handleSelectMultiple?.(item?.id)}>
									<div className={twMerge('relative mb-1.5 mt-2 rounded-xl transition-all', selected.has(item?.id) && 'outline outline-2 outline-[var(--rose-violet)]')}>
										<ImageLoader src={item?.image} className='w-14 h-14 rounded-xl object-cover object-center' />
										<div
											className={twMerge(
												'absolute -top-2 -left-1 grid h-[18px] w-[18px] place-content-center rounded-full border-2 border-white bg-[var(--rose-violet)] opacity-0 transition-opacity',
												selected.has(item?.id) && 'opacity-100',
											)}>
											<img src={check} alt='check' />
										</div>
									</div>
									<p className='line-clamp-2 text-center text-xxs text-gray-600'>{item?.name}</p>
								</div>
							);
						} else {
							return (
								<div key={index} className='flex-none w-14 cursor-pointer' onClick={() => handleSelect?.(item)}>
									<div className={'relative mb-1.5 mt-2 rounded-xl transition-all'}>
										<ImageLoader src={item?.image} className='w-14 h-14 rounded-xl object-cover object-center' />
									</div>
									<p className='line-clamp-2 text-center text-xxs text-gray-600'>{item?.name}</p>
								</div>
							);
						}
					})}
				</div>
			</div>
		</div>
	);
};

const Category = () => {
	const [selected, setSelected] = useState(null);
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const handleSelect = (item) => {
		setSelected(item);
		setIsShowBottomSheet(true);
	};

	const handleCloseBottomSheet = () => {
		setSelected(null);
		setIsShowBottomSheet(false);
	};

	const listCategoryProps = {
		handleSelect,
	};

	const categoryDetailProps = {
		...selected,
		onClose: handleCloseBottomSheet,
	};

	return (
		<>
			<ListCategory {...listCategoryProps} />
			<BottomSheet key={'category-detail'} open={isShowBottomSheet} onDismiss={handleCloseBottomSheet} header={false}>
				<CategoryDetail {...categoryDetailProps} />
			</BottomSheet>
		</>
	);
};

export default Category;
